module.exports = __webpack_public_path__ + "static/media/icn-popcorn-chrome-128.051e1538.png";